export default __webpack_public_path__ + "static/media/basic-pin-small-14.1c33bb37.png";